export const ROLE_TYPE = {
  PRIMARY_BENEFICIARY: "Primary Beneficiary",
  CONTINGENT_BENEFICIARY: "Contingent Beneficiary",
  OWNER: "Owner",
  JOINT_OWNER: "Joint Owner",
  EMPLOYER: "Employer",
  TRUST: "Trust",
  INSURED: "Insured",
  JOINT_INSURED: "Joint Insured",
  SPOUSE: "Spouse",
  SECONDARY_ADDRESSEE: "Secondary Addressee",
  GUARDIAN: "Guardian",
  PAYOR: "Payor",
  JOINT_PAYOR: "Joint Payor",
};

export type RoleType = (typeof ROLE_TYPE)[keyof typeof ROLE_TYPE];

export interface Role {
  id: number | null;
  insured_id: number | null;
  beneficiary_amount: number | null;
  relationship: string | null;
  role: RoleType;
}

export function generateRoleData(rawRoles: Role[]) {
  const roles: Record<RoleType, number | null> = Object.values(
    ROLE_TYPE
  ).reduce((acc, curr) => ({ ...acc, [curr]: null }), {});

  let beneficiary_amount = null;
  let relationship = null;
  const role_for_id: Record<RoleType, number | null> = Object.values(
    ROLE_TYPE
  ).reduce((acc, curr) => ({ ...acc, [curr]: null }), {});
  if (rawRoles) {
    rawRoles.forEach(role => {
      if (role.beneficiary_amount) beneficiary_amount = role.beneficiary_amount;
      if (role.relationship) relationship = role.relationship;
      if (role.insured_id && Object.keys(role_for_id).includes(role.role)) {
        role_for_id[role.role] = role.insured_id;
      }
      roles[role.role] = role.id;
    });
  }

  return { roles, beneficiary_amount, relationship, role_for_id };
}

export const isBeneficiaryRole = (r: RoleType) =>
  r === ROLE_TYPE.CONTINGENT_BENEFICIARY || r === ROLE_TYPE.PRIMARY_BENEFICIARY;
